import Model from "~/models/_Model";
import Student from "./Student";

export default class StudentContacts extends Model {
  // Define a base url for a REST API
  baseURL() {
    return super.baseURL() + "/mtss";
  }

  // Set the resource route of the model
  resource() {
    return "student-contacts";
  }

  relations() {
    return {
      student: Student,
    };
  }

  /**
   * Helper Methods
   */
  getStaffDisplayName(attribute) {
    if (
      Object.hasOwn(this, attribute + "_info") &&
      this[attribute + "_info"] != null
    ) {
      return this[attribute + "_info"].display_name;
    }
    return this[attribute] || "None";
  }

  /**
   * Helper Attributes
   */
}
